import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Field} from 'react-final-form';

const RadioButton = (
  {name, value, label, validatorsArray, className, containerStyle, circleStyle, ...radioProps}
) => {
  const composeValidators = (...validators) => (val, allValues) =>
    validators.reduce((error, validator) => error || validator(val, allValues), undefined);

  const classes = classNames('radio', {
    [className]: Boolean(className),
  });

  return (
    <Field
      name={name}
      validate={composeValidators(...validatorsArray)}
      value={value}
      type="radio"
    >
      {({input, meta}) => (
        <div className={classes} style={containerStyle}>
          <span className="radio__box">
            <input
              {...input}
              {...radioProps}
              className="radio__input"
              value={value}
              type="radio"
              name={name}
              id={value}
            />
            <i className="radio__circle" style={circleStyle}/>
            {meta.error && meta.touched &&
              <span className="form__error">{meta.error}</span>
            }
          </span>
          <label className="radio__label" htmlFor={value}>{label}</label>
        </div>
      )}
    </Field>
  );
};

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  validatorsArray: PropTypes.arrayOf(PropTypes.func),
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
  containerStyle: PropTypes.shape({}),
  circleStyle: PropTypes.shape({}),
};

RadioButton.defaultProps = {
  validatorsArray: [],
  className: '',
  containerStyle: {},
  circleStyle: {},
};

export default RadioButton;
